import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import isLoggedIn from '../../../utils/auth';

import {DiamondSourceBannerContainer} from '../common/DiamondSourceBanner';

import {DiamondsDefaultContainer} from './DiamondsDefault';
import {DiamondsOnlineContainer} from './DiamondsOnline';
import {DiamondsRapnetContainer} from './DiamondsRapnet';
import {DiamondsLabContainer} from './DiamondsLab';



import * as diamondsActionCreators from '../../../actions/diamonds';
let allActionCreators = Object.assign({}, diamondsActionCreators);




class Diamonds extends React.Component {

  getPageBody() {
    if(!this.props.diamonds.source) {
      return <DiamondsDefaultContainer />;
    }

    switch(this.props.diamonds.source) {
      case 'online':
        return <DiamondsOnlineContainer />;
      case 'rapnet':
        return <DiamondsRapnetContainer />;
      case 'lab':
        return <DiamondsLabContainer />;
      default:
        return <DiamondsDefaultContainer />;
    }
  }

	render() {

		return <div className='Diamonds'>
			<DiamondSourceBannerContainer showTabs={true} />
      <div className='diamondsBodyWrapper'>
        {this.getPageBody()}
      </div>
		</div>;
	}
}
export default Diamonds;

function mapStateToProps(state) {
  return {
    diamonds: state.diamonds,
  };
}

export const DiamondsContainer = connect(
  mapStateToProps,
  allActionCreators
)(Diamonds);